<template>
  <v-icon
    v-bind="$attrs"
    :color="noColor ? '' : iconMapping.color"
    class="p-social-media-icon"
    :class="iconMapping.icon"
  >
    {{ iconMapping.icon }}
  </v-icon>
</template>


<script>
import { socialMedia } from '@/constants'


export default {
  props: {
    id: {
      type: Number
    },
    noColor: {
      type: Boolean,
      default: false
    }
  },


  computed: {
    mappings () {
      const mappings = {}

      mappings[socialMedia.facebook] = {
        icon: 'mdi-facebook',
        color: '#3b5998'
      }

      mappings[socialMedia.instagram] = {
        icon: 'mdi-instagram',
        color: 'purple'
      }

      mappings[socialMedia.wordPress] = {
        icon: 'mdi-wordpress',
        color: '#00749C'
      }

      return mappings
    },

    iconMapping () {
      return this.mappings[this.id] || {}
    }
  }
}
</script>
